module.exports = __webpack_public_path__ + "files/53e6873eb8f52d2a98b2ad8db55c0656.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/windows_dark.png
// module id = 586
// module chunks = 60